import { KnownCip30WalletId, } from "./types";
export const isCIPErrorWithCode = (e) => typeof e?.code === "number" &&
    typeof e.info === "string";
export const isPaginateError = (e) => typeof e?.maxSize === "number";
const DefaultIgnoreWalletIds = [
    KnownCip30WalletId.ccvault,
    KnownCip30WalletId.Typhon,
];
const KnownWalletIds = Object.values(KnownCip30WalletId);
/**
 * Get the initial CIP-30 api for given walletId
 * @param walletId
 * @returns
 */
export const getInitialApi = (walletId, iframe = false) => {
    const context = getCardanoContext(iframe);
    return context.cardano?.[walletId];
};
const getCardanoContext = (iframe) => iframe
    ? window.parent
    : window;
/**
 * Returns available walletIds
 * @param param0
 * @returns
 */
export const getAvailableWallets = ({ allowList, onlyKnown, ignoreList = DefaultIgnoreWalletIds, iframe = false, } = {}) => {
    const context = getCardanoContext(iframe);
    const entries = Object.entries(context.cardano ?? {});
    let walletIds = entries
        .filter(([, value]) => typeof value?.enable === "function")
        .map(([key]) => key);
    if (allowList) {
        walletIds = walletIds.filter((id) => allowList.includes(id));
    }
    if (ignoreList) {
        walletIds = walletIds.filter((id) => !ignoreList.includes(id));
    }
    if (onlyKnown) {
        walletIds = walletIds.filter((id) => KnownWalletIds.includes(id));
    }
    const availableWallets = [];
    walletIds.forEach((key) => {
        const api = getInitialApi(key, iframe);
        if (api) {
            availableWallets.push([key, api]);
        }
    });
    return availableWallets;
};
//# sourceMappingURL=cip30.utils.js.map